<script setup lang="ts">
interface LogoConfig {
  name: string;
  show?: boolean;
  component: any;
  colorClass: string;
}

const props = withDefaults(defineProps<{ logoConfigs: LogoConfig[]; variant?: 'header' | 'footer' }>(), {
  variant: 'header'
});

const visibleLogos = computed(() => props.logoConfigs.filter(logo => logo.show));

const isLastLogo = (index: number) => index === visibleLogos.value.length - 1;
</script>

<template>
  <template v-for="(logo, index) in visibleLogos" :key="logo.name">
    <component :is="logo.component" :class="logo.colorClass" role="img" :aria-label="`${logo.name} logo`" />
    <Separator
      v-if="!isLastLogo(index)"
      orientation="vertical"
      class="h-6 w-0.5 bg-gainsboro"
      :class="{ 'bg-stormcloud': variant === 'footer' }"
      role="separator"
      aria-hidden="true"
    />
  </template>
</template>
